import { Page, Text, View, Document, Image } from "@react-pdf/renderer";
import { Font, StyleSheet } from "@react-pdf/renderer";
import { handleArabicPunctuation } from "../../function";

Font.register({
  family: "IBM Plex Sans Arabic",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Regular.ttf",
});
Font.register({
  family: "IBM Plex Sans Arabic Bold",
  src: "/fonts/IBMPlexSansArabic/IBMPlexSansArabic-Bold.ttf",
});

export const Styles = StyleSheet.create({
  portraitPage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    lineHeight: "1.7",
  },
  landscapePage: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: "9px",
    padding: "57px 17px",
    width: "100%",
    lineHeight: "1.7",
  },
  portraitTopSection: {
    flexDirection: "row",
    height: "48%",
  },
  landscapeTopSection: {
    flexDirection: "row",
    width: "50%",
    height: "100%",
  },
  portraitBottomSection: {
    flexDirection: "row",
    height: "50%",
    width: "100%",
  },
  arrowIconCont: {
    fontSize: "6px",
    width: "40px",
    color: "#FF0000",
    alignItems: "space-between",
    marginTop: "-8px",
  },
  arrowIconCont2: {
    fontSize: "6px",
    color: "#FF0000",
    width: "40px",
  },
  arrowIcon: {
    width: "12px",
    height: "7px",
  },
  curveArrowIcon: {
    width: "20px",
    height: "15px",
  },
  portraitArabTopSection1: {
    width: "80%",
    textAlign: "left",
  },
  portraitEngTopSection2: {
    width: "60%,",
    transform: "rotate(-90deg)",
    height: "120%",
    marginLeft: "25px",
    textAlign: "right",
  },
  landscapeEngTopSection3: {
    marginLeft: "13px",
    height: "120%",
    width: "64%,",
    transform: "rotate(-90deg)",
    textAlign: "right",
    marginTop: "-10px",
  },
  landscapeArabTopSection3: {
    textAlign: "left",
    height: "100%",
    width: "80%,",
  },
  pointingText: {
    marginBottom: "6px",
    fontFamily: "IBM Plex Sans Arabic Bold",
  },
  flexRowReverse: {
    flexDirection: "row-reverse",
  },
  flexWrap: {
    flexWrap: "nowrap",
  },
  ml1: {
    marginLeft: "2pt",
  },
});

const MyDocument8 = ({ arabChunks, engChunks }) => {
  let landscapePagesArray = [];
  const arabicText = (arabicChunks) => {
    return (
      // iterate over the text divided in lines
      arabicChunks?.map((line, idx) => {
        return (
          <View style={[Styles.flexRowReverse, Styles.flexWrap, {}]} key={idx}>
            {
              // divide every line into words and arrange them RTL
              line.map((word, idxWord) => {
                // correct every word for paired punctuation
                return handleArabicPunctuation(word).map(
                  (punctuationWord, punctuationIdx) => {
                    return (
                      <Text style={Styles.ml1} key={punctuationIdx}>
                        {punctuationWord}
                      </Text>
                    );
                  }
                );
              })
            }
          </View>
        );
      })
    );
  };
  const landscapePages = () => {
    let k = 0,
      m = 1;
    for (let i = 1; i < 4; i++) {
      landscapePagesArray.push(
        <>
          <View
            style={{
              textAlign: "right",
              width: "100%",
              height: "50%",
              flexDirection: "row",
            }}
          >
            <View style={Styles.landscapeTopSection}>
              <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { marginTop: "10px" }]}
                ></Image>
              </View>
              <View style={[Styles.landscapeArabTopSection3]}>
                {engChunks[i + k]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
              <View style={{ width: "57px" }}></View>
            </View>
            <View style={Styles.landscapeTopSection}>
              <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { marginTop: "10px" }]}
                ></Image>
              </View>
              <View style={Styles.landscapeArabTopSection3}>
                {engChunks[i + m]?.map((word, idx) => {
                  return (
                    <Text style={{}} key={idx}>
                      {word}
                    </Text>
                  );
                })}
              </View>
              <View style={{ width: "57px" }}></View>
            </View>
          </View>
          <View
            style={{
              textAlign: "left",
              height: "50%",
              width: "100%",
              flexDirection: "row",
            }}
          >
            <View style={Styles.landscapeTopSection}>
              <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
                <Image
                  src="/images/rightcurvepdf_arrow.png"
                  style={[Styles.curveArrowIcon, { marginTop: "5px" }]}
                ></Image>
              </View>

              <View style={[Styles.landscapeEngTopSection3]}>
                {arabicText(arabChunks[i + k])}
              </View>
            </View>
            <View style={Styles.landscapeTopSection}>
              <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
                <Image
                  src="/images/rightpdf_arrow.png"
                  style={[Styles.arrowIcon, { marginTop: "10px" }]}
                ></Image>
              </View>
              <View style={[Styles.landscapeEngTopSection3]}>
                {arabicText(arabChunks[i + m])}
              </View>
            </View>
          </View>
        </>
      );
      m = m + 1;
      k = k + 1;
    }
  };
  landscapePages();
  return (
    <Document>
      <Page size="A5" style={Styles.portraitPage}>
        <View style={Styles.portraitTopSection}>
          <View style={[Styles.arrowIconCont, { marginRight: "6px" }]}>
            <Text style={[Styles.pointingText, { marginTop: "-5px" }]}>
              Start of Text
            </Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
          <View style={Styles.portraitArabTopSection1}>
            {engChunks[0]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>

        <View style={Styles.portraitBottomSection}>
          <View
            style={[
              Styles.arrowIconCont2,
              { marginTop: "16px", alignItems: "flex-end", marginRight: "6px" },
            ]}
          >
            <Text style={Styles.pointingText}>بداية النص</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View style={[Styles.portraitEngTopSection2]}>
            {arabicText(arabChunks[0])}
          </View>
        </View>
      </Page>
      {landscapePagesArray.map((array, index) => {
        return (
          <Page
            size="A4"
            style={Styles.landscapePage}
            orientation="landscape"
            key={index}
          >
            {array}
          </Page>
        );
      })}
      <Page size="A5" style={[Styles.portraitPage]}>
        <View style={Styles.portraitTopSection}>
          <View
            style={[
              Styles.arrowIconCont,
              { marginRight: "6px", marginTop: "3px" },
            ]}
          >
            <Image
              src="/images/rightpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
          <View
            style={[
              Styles.arrowIconCont,
              { position: "absolute", top: "90%", marginRight: "6px" },
            ]}
          >
            <Text style={Styles.pointingText}>End of text</Text>
            <Image
              src="/images/rightpdf_arrow.png"
              style={Styles.arrowIcon}
            ></Image>
          </View>
          <View style={Styles.portraitArabTopSection1}>
            {engChunks[7]?.map((word, idx) => {
              return (
                <Text style={{}} key={idx}>
                  {word}
                </Text>
              );
            })}
          </View>
        </View>

        <View style={Styles.portraitBottomSection}>
          <View
            style={[
              Styles.arrowIconCont2,
              { marginTop: "28px", marginRight: "6px" },
            ]}
          >
            <Image
              src="/images/rightpdf_arrow.png"
              style={[Styles.arrowIcon, { alignSelf: "flex-end" }]}
            ></Image>
          </View>
          <View style={[Styles.portraitEngTopSection2]}>
            {arabicText(arabChunks[7])}
          </View>
          <View style={[Styles.arrowIconCont2, { marginRight: "-45px" }]}>
            <View style={{ position: "absolute", right: "-45px", top: "98%" }}>
              <Text style={Styles.pointingText}>نهاية النص</Text>
              <Image
                src="/images/leftpdf_arrow.png"
                style={Styles.arrowIcon}
              ></Image>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default MyDocument8;
